import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { SnackbarProvider } from 'notistack';
import { HashRouter } from "react-router-dom";

export function mainApp(rootElement) {
    ReactDOM.render(
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <HashRouter>
                <App />
            </HashRouter>
        </SnackbarProvider>,
        rootElement
    );
}